import { render, staticRenderFns } from "./UserAccountUserList.vue?vue&type=template&id=5b210b80&"
import script from "./UserAccountUserList.vue?vue&type=script&lang=js&"
export * from "./UserAccountUserList.vue?vue&type=script&lang=js&"
import style0 from "./UserAccountUserList.vue?vue&type=style&index=0&id=5b210b80&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports